(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/objectWithoutProperties', 'react', 'react-emotion', '../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/objectWithoutProperties'), require('react'), require('react-emotion'), require('../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global._extends, global.objectWithoutProperties, global.react, global.reactEmotion, global.colors);
    global.GreyBox = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _extends2, _objectWithoutProperties2, _react, _reactEmotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _extends3 = _interopRequireDefault(_extends2);

  var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

  var React = _interopRequireWildcard(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 3px;\n    padding: 1rem 1.5rem;\n    transition: all 0.25s;\n  '], ['\n    background-color: ', ';\n    border: 1px solid ', ';\n    border-radius: 3px;\n    padding: 1rem 1.5rem;\n    transition: all 0.25s;\n  ']);

  var GreyBox = function GreyBox(_ref) {
    var children = _ref.children,
        className = _ref.className,
        props = (0, _objectWithoutProperties3.default)(_ref, ['children', 'className']);
    return React.createElement(
      'div',
      (0, _extends3.default)({ className: (0, _reactEmotion.cx)(classNames.greyBox, className) }, props),
      children
    );
  };

  var classNames = {
    greyBox: (0, _reactEmotion.css)(_templateObject, _colors2.default.platinum, _colors2.default.silver)
  };

  exports.default = GreyBox;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/GreyBox.js
// module id = 828
// module chunks = 1